import React, { useState, useRef, Fragment } from "react";
import { TextField } from "@material-ui/core";
import { isNumber, isSpecial, isEnglish } from "../../lib/Common";

function CompanySite(props) {
  const classes = props.useStyles();
  const [errorText, setErrorText] = useState("");
  const [errorValue, setErrorValue] = useState(false);
  const CompanySiteRef = useRef(null);

  return (
    <Fragment>
      <TextField
        className={classes.TextField}
        fullWidth
        inputRef={CompanySiteRef}
        error={errorValue}
        helperText={errorText}
        label="회사소재지"
        type="text"
        variant="filled"
        placeholder="예: 마포구 공덕동, 영등포구 여의도동"
        inputProps={{
          maxLength: 50,
        }}
        onBlur={(e) => {
          if (e.target.value.length === 0) {
            setErrorText("");
            setErrorValue(false);
          } else if (
            isNumber.test(e.target.value) ||
            isSpecial.test(e.target.value) ||
            isEnglish.test(e.target.value)
          ) {
            setErrorText("한글만 입력 가능합니다.");
            setErrorValue(true);
            CompanySiteRef.current.focus();
          } else if (e.target.value.length <= 1) {
            setErrorText("2글자 이상 데이터 입력하세요.");
            setErrorValue(true);
            CompanySiteRef.current.focus();
          } else {
            setErrorText("");
            setErrorValue(false);
            props.onChangeCompanySite(e.target.value);
          }
        }}
        name="CompanySite"
        defaultValue={props.companySite}
      />
    </Fragment>
  );
}
export default CompanySite;
